export const replaceStringWithYear = (data: string) => {
  const currentYear = new Date().getFullYear().toString();
  const copyrightText = data.replace('{{currentYear}}', currentYear);
  return copyrightText;
};
